module.exports = __webpack_public_path__ + "static/media/help.2dce384a.svg";